import { Directive } from '@angular/core';

@Directive({
    selector: '[fiCdkNoDrag]',
    host: {
        '(mousedown)': 'onMouseDown($event)',
    },
    standalone: false,
})
export class FiCdkNoDragDirective {
    onMouseDown($event: MouseEvent) {
        $event.stopPropagation();
    }
}
